export const buildPlanOrderStatusReturnUrl = ({ returnPath, email }) => {
	const encodedReturnPath = encodeURIComponent(returnPath || '/studio');
	const encodedEmail = encodeURIComponent(email || '');

	return `${window.location.origin}/order-status?result=success&paymentFor=plan&returnPath=${encodedReturnPath}&email=${encodedEmail}`;
};
